import { useState } from 'react'
import { Alert, Button, Dialog, Field, Input } from '@/components/common'
import styles from './experienceWorkspace.module.css'
import { TargetPicker } from './experienceEditorControls'
import { duplicateEventLayout, eventLayoutCopyIssue, experienceTargetOptions } from './experienceModel'
import { gamePageLabel } from './gamePageModel'

export function EventLayoutCopyDialog({ experience, template, catalog, onCopy, onClose }) {
  const [kind, setKind] = useState('league')
  const [value, setValue] = useState('')
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const suggestedName = experienceTargetOptions(catalog, kind).find((item) => item.value === value)?.label || `${gamePageLabel(template).slice(0, 75)} copy`
  const issue = eventLayoutCopyIssue(experience, { kind, value })
  const copy = () => {
    try { onCopy(duplicateEventLayout(experience, template.id, { kind, value }, name.trim() || suggestedName)); onClose() }
    catch (failure) { setError(failure.message) }
  }
  return <Dialog open title="Duplicate game page" onClose={onClose} footer={<><Button variant="secondary" onClick={onClose}>Cancel</Button><Button disabled={Boolean(issue)} onClick={copy}>Create copy</Button></>}>
    <div className={styles.copyDialog}><p>Copy {gamePageLabel(template)} to another sport, league or game.</p>
    <TargetPicker catalog={catalog} kind={kind} value={value} onKindChange={setKind} onChange={setValue} disabled={false} />
    <Field label="Name"><Input value={name} maxLength={80} placeholder={suggestedName} onChange={(event) => setName(event.target.value)} /></Field>
    {value && issue ? <Alert variant="warning">{issue}</Alert> : null}
    {error ? <Alert variant="error">{error}</Alert> : null}</div>
  </Dialog>
}
